
import { computed, defineComponent } from 'vue'
import { getColor, getIcon, getTooltip } from '~/functions/esg'
import {
  useGetEsgMeasureComparisonQuery,
  type EsgMeasureComparisonType,
} from '~/types/types'

export default defineComponent({
  props: {
    firstQuestionnaireId: {
      type: Number,
      required: true,
    },
    secondQuestionnaireId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    // Use an array of questions to enable extensibility.
    const { result, loading } = useGetEsgMeasureComparisonQuery({
      input: {
        firstQuestionnaireId: props.firstQuestionnaireId,
        secondQuestionnaireId: props.secondQuestionnaireId,
      },
    })

    const measureComparison = computed<EsgMeasureComparisonType>(() => {
      return (
        result.value?.getEsgMeasureComparison ?? {
          environmental: [],
          social: [],
          governance: [],
          disclosure: [],
        }
      )
    })

    return {
      measureComparison,
      loading,
      result,
      getColor,
      getIcon,
      getTooltip,
    }
  },
})
